import { Box, Divider, Stack, Typography } from "@mui/material";
import React from "react";
import HorizontalFill from "@entrilia/shared/components/HorizontalFill";
import type { ClientInfoExtended, ReportTemplate } from "../../../../../../api/types/svTypes.ts";
import { Status } from "../../../../../../api/types/svTypes.ts";
import { formatFundType } from "../../../report-lists/templates/helpers/reportTemplateHelper.ts";
import BackToTemplates from "./backToTemplates/BackToTemplates";
import DraftStatus from "./status/DraftStatus";
import LiveStatus from "./status/LiveStatus";

interface Props {
  template: ReportTemplate;
  clientTitle: string;
  companies: ClientInfoExtended[];
}

export default function TemplateActionHeader({
  template,
  children,
  clientTitle,
  companies,
}: React.PropsWithChildren<Props>) {
  return (
    <Box sx={{ display: "flex", p: ".7rem 1.3rem", alignItems: "center", gap: 2 }}>
      <BackToTemplates companies={companies} />
      <Divider orientation="vertical" flexItem />
      <Stack sx={{ gap: 0.5 }}>
        <Box sx={{ display: "flex", gap: 1, alignItems: "center" }}>
          <Typography variant="h6">{template.name}</Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {template.status === Status.Live ? <LiveStatus /> : <DraftStatus />}
          </Box>
        </Box>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Box>
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
              {clientTitle}
            </Typography>
          </Box>
          {template.fundTypes.length > 0 && (
            <Divider orientation="vertical" variant="middle" flexItem sx={{ my: 0.5 }} />
          )}
          <Box>
            <Typography variant="caption" sx={{ color: "text.secondary" }}>
              {template.fundTypes.map(formatFundType).join(", ")}
            </Typography>
          </Box>
        </Box>
      </Stack>
      <HorizontalFill />
      <Box sx={{ flexGrow: 1 }}></Box>
      {children}
    </Box>
  );
}
